import LandingTab from './landingTab';

export default LandingTab;
